<template>
  <div></div>
</template>

<script>
export default {

  mounted() {

    // 店舗ID
    this.$store.commit('setStoreId', this.$cookies.get('storeId'))

    this.getLineId()
  },
  methods: {
    getLineId() {
      const p = new Promise((resolve, reject) => {
      // URLを取得
      var url = new URL(window.location.href);
      // URLSearchParamsオブジェクト取得
      var urlStr = url.searchParams;
      // アクセストークン取得
      var params = new URLSearchParams();
      params.append('grant_type', 'authorization_code');
      params.append('code', urlStr.get('code'));
      params.append('redirect_uri',  this.$store.state.line_platform.redirect_uri);
      params.append('client_id', this.$cookies.get('channelId'));
      params.append('client_secret', urlStr.get('state'));
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      this.axios  
        .post("https://api.line.me/oauth2/v2.1/token", params, config)
        .then((response) => {
          // アクセストークン
          var acdessToken = response.data.access_token
          // ユーザーID取得
          const userConfig = {
            headers: {
              'Authorization': 'Bearer {' + acdessToken + '}'
            }
          }
          this.axios  
            .get("https://api.line.me/v2/profile", {
              headers: {
                Authorization: `Bearer `+ acdessToken,
              }
            })
            .then((response) => {
              // LineID設定
              this.$store.commit('setLineId', response.data.userId)
              this.screenBranch()
              resolve()
            })
            .catch((e) => {
              return
            });
        })
        .catch((e) => {
          return
        });
      });
      return p;
    },
    screenBranch() {
      // 画面分岐処理
      this.axios  
        .get(this.$store.state.baseUrl + "line/status/" + this.$store.state.storeId + "/" + this.$store.state.lineId)
        .then((response) => {
          if (this.$cookies.isKey('redirectUrl')) {
            var redirectUrl =  this.$cookies.get('redirectUrl')
            this.$cookies.remove('redirectUrl')
            window.location.href = redirectUrl
          } else {
            if (response.data.status == 0) {
              //画面遷移：会員登録メニュー(同じLINE IDで未登録)
              this.$router.push({ name: "MemberRegistMenu", params: {} });
            } else if (response.data.status == 1) {
              //画面遷移：QRコード(同じLINE IDで登録済み、且つ本会員未登録)
              this.$router.push({ name: "Qrcode", params: {} });
            } else if (response.data.status == 2) {
              //画面遷移：会員メニュー(同じLINE IDで本会員連携済み)
              this.$router.push({ name: "MemberMenu", params: {} });
            }
          }
        })
        .catch((e) => {
          return
        });
    }
  }
};
</script>
